import React, { useState } from "react";
import { Container, Row } from "shards-react";
import PageTitle from "./../components/common/PageTitle";
import { useAuth } from '../contexts/AuthContext';
import SkeletonArticle from "../components/skeleton/SkeletonArticle";
import useWindowDimensions from "../hooks/useWindowDimensions";

const PowerBi = ({ title, resource }) => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const {height, width} = useWindowDimensions();

  function hideSkeleton() {
    setLoading(false);
  }
  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle title={title} subtitle={currentUser.username ? currentUser.username : 'Your Company'} className="text-sm-left mb-3" />
      </Row>

      {loading && <SkeletonArticle />}
      {/* Page Header */}
      <div  className='z21-iframe'>
        <iframe onLoad={() => hideSkeleton()} title={title} width="100%" height={height - height*.05}
          src={currentUser && resource && currentUser.links[resource]} className='z21-iframe'></iframe>
      </div>
      )
    </Container>
  );
}
export default PowerBi;